(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blog-layout"] && !Shopify.designMode) return;
  try {
    class BlogMenu extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('details');
      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      this.removeEventListener('keydown', this.onKeydown);
    }

    onDocumentClick = (event) => {
      if (this.select.open && !this.select.contains(event.target)) this.select.open = false;
    };

    onKeydown = (event) => {
      if (event.key !== 'Escape' || !this.select.open) return;

      this.select.open = false;
      this.select.querySelector('summary').focus();
    };
  }

  if (!customElements.get('blog-menu')) customElements.define('blog-menu', BlogMenu);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["category-top10-script"] && !Shopify.designMode) return;
  try {
    class CategoryTop10 extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-top10-track]');
      this.arrows = Array.from(this.querySelectorAll('.category-top10__arrow'));
      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => this.move(Number(arrow.dataset.direction)));
      });
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      /* 2枚目の画像は、マウスを乗せたときに読み込む */
      this.onPointerOver = (event) => {
        if (event.pointerType !== 'mouse') return;
        this.querySelectorAll('img[data-src]').forEach((image) => {
          image.srcset = image.dataset.srcset;
          image.src = image.dataset.src;
          image.removeAttribute('data-srcset');
          image.removeAttribute('data-src');
        });
      };
      this.addEventListener('pointerover', this.onPointerOver);
      this.load();
    }

    async load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) throw new Error(response.status);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const items = Array.from(html.querySelectorAll('[data-top10-item]'));
        if (items.length === 0) throw new Error('no items');
        items.forEach((item) => item.classList.add('category-top10__item'));
        this.track.replaceChildren(...items);
        this.track.removeAttribute('aria-busy');
        this.updateArrows();
      } catch (error) {
        this.hidden = true;
      }
    }

    /* 1枚分ずつ送る。スクロールのイベントを待たずに矢印の状態を更新する */
    move(direction) {
      const item = this.track.querySelector('li');
      if (!item) return;
      const step = item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
      const max = this.track.scrollWidth - this.track.clientWidth;
      const left = Math.min(Math.max((Math.round(this.track.scrollLeft / step) + direction) * step, 0), max);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left, behavior: reduceMotion ? 'instant' : 'smooth' });
      this.updateArrows(left);
    }

    updateArrows(left = this.track.scrollLeft) {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const [previous, next] = this.arrows;
      previous.disabled = left <= 1;
      next.disabled = left >= max - 1;
    }
  }

  if (!customElements.get('category-top10')) customElements.define('category-top10', CategoryTop10);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-script"] && !Shopify.designMode) return;
  try {
    /* 商品カード：画像のスライド（矢印・区切りバー）と、2枚目以降の画像の読み込み */
  class ProductCard extends HTMLElement {
    connectedCallback() {
      this.slides = this.querySelector('.product-card__slides');
      if (!this.slides) return;
      this.bars = Array.from(this.querySelectorAll('.product-card__bar'));
      this.index = 0;

      this.slides.addEventListener('scroll', () => this.update(), { passive: true });
      this.querySelectorAll('.product-card__arrow').forEach((arrow) => {
        arrow.addEventListener('click', () => this.go(this.index + Number(arrow.dataset.direction)));
      });
      /* 2枚目以降は、PC はマウスを乗せたとき・フォーカスしたとき、スマホは横スクロールを始めたときに読み込む */
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.loadImages();
      });
      this.addEventListener('focusin', () => this.loadImages());
      this.slides.addEventListener('scroll', () => this.loadImages(), { once: true, passive: true });
    }

    loadImages() {
      this.slides.querySelectorAll('img[data-src]').forEach((image) => {
        image.srcset = image.dataset.srcset;
        image.src = image.dataset.src;
        image.removeAttribute('data-srcset');
        image.removeAttribute('data-src');
      });
    }

    update() {
      this.select(Math.round(this.slides.scrollLeft / this.slides.clientWidth));
    }

    select(index) {
      if (index === this.index) return;
      this.index = index;
      this.bars.forEach((bar, i) => bar.classList.toggle('product-card__bar--active', i === index));
    }

    /* 端では反対の端へ戻る。スクロールのイベントを待たずに位置を更新する */
    go(index) {
      this.loadImages();
      const images = this.slides.querySelectorAll('.product-card__image');
      const next = (index + images.length) % images.length;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.slides.scrollTo({ left: images[next].offsetLeft, behavior: reduceMotion ? 'instant' : 'smooth' });
      this.select(next);
    }
  }

  if (!customElements.get('product-card')) customElements.define('product-card', ProductCard);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.product-gallery__track');
      this.slides = Array.from(this.querySelectorAll('.product-gallery__slide'));
      this.thumbs = Array.from(this.querySelectorAll('.product-gallery__thumb'));
      this.dots = Array.from(this.querySelectorAll('.product-gallery__dot'));
      this.counter = this.querySelector('[data-gallery-index]');
      this.previous = this.querySelector('.product-gallery__arrow--previous');
      this.next = this.querySelector('.product-gallery__arrow--next');
      this.dialog = this.querySelector('.product-zoom');
      this.index = Number(this.dataset.startIndex || 0);

      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.go(Number(thumb.dataset.index))));
      [this.previous, this.next].forEach((arrow) => {
        arrow?.addEventListener('click', () => this.go(this.index + Number(arrow.dataset.direction)));
      });
      this.querySelectorAll('[data-zoom-index]').forEach((button) => {
        button.addEventListener('click', () => this.openZoom(Number(button.dataset.zoomIndex)));
      });
      this.querySelector('[data-zoom-close]')?.addEventListener('click', () => this.dialog.close());
      this.dialog?.addEventListener('close', () => this.slides[this.index]?.querySelector('button')?.focus());

      /* バリエーションを変えたら、そのバリエーションの画像へ移る */
      this.onVariantChange = (event) => {
        const index = this.slides.findIndex((slide) => slide.dataset.mediaId === event.detail.mediaId);
        if (index >= 0) this.go(index);
      };
      this.root = this.closest('[data-product-page]') || document;
      this.root.addEventListener('product:variant-change', this.onVariantChange);

      /* 画面の幅が変わったら、表示中の画像の位置に合わせ直す */
      this.resizeObserver = new ResizeObserver(() => this.go(this.index, true));
      this.resizeObserver.observe(this.track);

      this.go(this.index, true);
    }

    disconnectedCallback() {
      this.root?.removeEventListener('product:variant-change', this.onVariantChange);
      this.resizeObserver?.disconnect();
    }

    get step() {
      if (this.slides.length < 2) return this.track.clientWidth;
      return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
    }

    onScroll() {
      if (this.scrolling) return;
      this.select(Math.round(this.track.scrollLeft / this.step));
    }

    /* 矢印・サムネイルでは、スクロールのイベントを待たずに表示を更新する */
    go(index, instant = false) {
      const next = Math.min(Math.max(index, 0), this.slides.length - 1);
      const target = this.slides[next];
      if (!target) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const behavior = instant || reduceMotion ? 'instant' : 'smooth';
      this.scrolling = behavior === 'smooth';
      clearTimeout(this.scrollTimer);
      if (this.scrolling) this.scrollTimer = setTimeout(() => (this.scrolling = false), 600);
      this.track.scrollTo({ left: target.offsetLeft - this.slides[0].offsetLeft, behavior });
      this.select(next);
    }

    select(index) {
      const next = Math.min(Math.max(index, 0), this.slides.length - 1);
      this.index = next;
      this.thumbs.forEach((thumb, i) => {
        if (i === next) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      this.revealThumb(this.thumbs[next]);
      this.dots.forEach((dot, i) => dot.classList.toggle('product-gallery__dot--active', i === next));
      if (this.counter) this.counter.textContent = next + 1;
      if (this.previous) this.previous.hidden = next === 0;
      if (this.next) this.next.hidden = next === this.slides.length - 1;
    }

    /* サムネイルの列だけをスクロールする（scrollIntoView はページごと動くため使わない） */
    revealThumb(thumb) {
      const list = thumb?.closest('.product-gallery__thumb-list');
      if (!list) return;
      const top = thumb.offsetTop;
      const bottom = top + thumb.offsetHeight;
      if (top < list.scrollTop) list.scrollTop = top;
      else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight;
    }

    openZoom(index) {
      if (!this.dialog) return;
      this.dialog.showModal();
      const item = this.dialog.querySelectorAll('.product-zoom__item')[index];
      this.dialog.scrollTop = item ? item.offsetTop : 0;
    }
  }

  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-listing"] && !Shopify.designMode) return;
  try {
    class ProductListing extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('[data-filter-drawer]');
      this.collapsed = new Set();
      this.expanded = new Set();
      this.desktopQuery = window.matchMedia('(min-width: 990px)');

      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('change', (event) => this.onChange(event));
      this.addEventListener('input', (event) => this.onInput(event));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.sortOpen) {
          event.preventDefault();
          this.closeSort(true);
        }
      });

      this.onDocumentClick = (event) => {
        if (this.sortOpen && !event.target.closest('[data-sort]')) this.closeSort();
      };
      document.addEventListener('click', this.onDocumentClick);

      /* PC の幅になったらドロワーを閉じ、絞り込みを左の列へ戻す */
      this.onViewportChange = () => {
        if (this.desktopQuery.matches && this.drawer?.open) this.drawer.close();
      };
      this.desktopQuery.addEventListener('change', this.onViewportChange);

      if (this.drawer) {
        this.drawer.addEventListener('close', () => this.onDrawerClose());
        this.drawer.addEventListener('click', (event) => {
          if (event.target === this.drawer) this.drawer.close();
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      this.desktopQuery.removeEventListener('change', this.onViewportChange);
    }

    get form() {
      return this.querySelector('[data-listing-form]');
    }

    get sortOpen() {
      return this.querySelector('[data-sort-toggle]')?.getAttribute('aria-expanded') === 'true';
    }

    onClick(event) {
      const target = event.target;

      const link = target.closest('a[data-listing-link]');
      if (link) {
        event.preventDefault();
        this.render(link.href);
        return;
      }

      const more = target.closest('a[data-load-more]');
      if (more) {
        event.preventDefault();
        this.loadMore(more);
        return;
      }

      const opener = target.closest('[data-filter-open]');
      if (opener) return this.openDrawer(opener);
      if (target.closest('[data-filter-close]')) return this.drawer.close();

      const toggle = target.closest('.facet-group__toggle');
      if (toggle) {
        const group = toggle.closest('[data-facet-group]');
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        if (open) this.collapsed.delete(group.dataset.facetGroup);
        else this.collapsed.add(group.dataset.facetGroup);
        this.setGroupOpen(group, open);
        return;
      }

      const showAll = target.closest('[data-facet-more]');
      if (showAll) {
        const group = showAll.closest('[data-facet-group]');
        const open = showAll.getAttribute('aria-expanded') !== 'true';
        if (open) this.expanded.add(group.dataset.facetGroup);
        else this.expanded.delete(group.dataset.facetGroup);
        this.setShowAll(group, open);
        return;
      }

      if (target.closest('[data-sort-toggle]')) {
        if (this.sortOpen) this.closeSort();
        else this.openSort();
        return;
      }

      const sortOption = target.closest('[data-sort-value]');
      if (sortOption) {
        this.form.elements.sort_by.value = sortOption.dataset.sortValue;
        this.closeSort(true);
        this.render(this.formUrl());
      }
    }

    onChange(event) {
      const target = event.target;
      if (target.matches('[data-price-range]')) {
        this.updatePrice(target);
        this.render(this.formUrl());
      } else if (target.form === this.form) {
        this.render(this.formUrl());
      }
    }

    onInput(event) {
      if (event.target.matches('[data-price-range], [data-price-input]')) this.updatePrice(event.target);
    }

    /* 価格のスライダーと入力欄をそろえる。端（0円・最高額）のときは入力欄を空にし、条件に含めない */
    updatePrice(source) {
      const price = source.closest('.facet-price');
      const [minRange, maxRange] = price.querySelectorAll('[data-price-range]');
      const [minInput, maxInput] = price.querySelectorAll('[data-price-input]');
      const max = Number(maxRange.max);

      if (source === minInput) minRange.value = minInput.value || 0;
      if (source === maxInput) maxRange.value = maxInput.value || max;
      if (Number(minRange.value) > Number(maxRange.value)) {
        if (source === minRange || source === minInput) minRange.value = maxRange.value;
        else maxRange.value = minRange.value;
      }
      if (source === minRange) minInput.value = Number(minRange.value) > 0 ? minRange.value : '';
      if (source === maxRange) maxInput.value = Number(maxRange.value) < max ? maxRange.value : '';

      price.style.setProperty('--min', minRange.value / max);
      price.style.setProperty('--max', maxRange.value / max);
    }

    formUrl() {
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(this.form)) {
        if (value !== '') params.append(key, value);
      }
      const query = params.toString();
      return query ? `${this.dataset.url}?${query}` : this.dataset.url;
    }

    async fetchSection(url, signal) {
      const request = new URL(url, window.location.origin);
      request.searchParams.set('section_id', this.dataset.sectionId);
      const response = await fetch(request, { signal });
      if (!response.ok) throw new Error(response.status);
      return new DOMParser().parseFromString(await response.text(), 'text/html');
    }

    /* 条件を変えた一覧を取り直し、data-listing-region の部分を差し替える */
    async render(url) {
      const target = new URL(url, window.location.origin);
      target.searchParams.delete('section_id');
      target.searchParams.delete('page');

      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      this.setAttribute('aria-busy', 'true');

      try {
        const html = await this.fetchSection(target, controller.signal);
        const next = html.querySelector('product-listing');
        if (!next) throw new Error('product-listing not found');

        const focusedId = this.contains(document.activeElement) ? document.activeElement.id : '';
        const scroller = this.querySelector('[data-drawer-body]');
        const scrollTop = scroller?.scrollTop;

        this.querySelectorAll('[data-listing-region]').forEach((region) => {
          const source = next.querySelector(`[data-listing-region="${region.dataset.listingRegion}"]`);
          if (source) region.replaceWith(source);
        });
        this.className = next.className;
        this.form.elements.sort_by.value = target.searchParams.get('sort_by') || '';
        this.applyGroupState();

        if (scroller) scroller.scrollTop = scrollTop;
        if (focusedId) document.getElementById(focusedId)?.focus({ preventScroll: true });
        this.querySelector('[data-listing-status]').textContent = next.dataset.status;
        /* ページの見出しなど、一覧の外にある件数もそろえる（検索結果の見出し） */
        document.querySelectorAll('[data-listing-count-label]').forEach((label) => {
          label.textContent = next.dataset.countLabel;
        });
        history.replaceState(history.state, '', `${target.pathname}${target.search}`);
      } catch (error) {
        if (error.name !== 'AbortError') window.location.assign(target.href);
      } finally {
        if (this.controller === controller) this.removeAttribute('aria-busy');
      }
    }

    /* 次のページの商品を一覧の後ろに足す。URL は変えない */
    async loadMore(link) {
      if (link.getAttribute('aria-busy') === 'true') return;
      link.setAttribute('aria-busy', 'true');
      try {
        const html = await this.fetchSection(link.href);
        const items = Array.from(html.querySelectorAll('[data-listing-grid] > li'));
        this.querySelector('[data-listing-grid]').append(...items);
        const region = html.querySelector('[data-load-more-region]');
        if (region) this.querySelector('[data-load-more-region]').replaceWith(region);
        items[0]?.querySelector('a')?.focus({ preventScroll: true });
      } catch (error) {
        window.location.assign(link.href);
      }
    }

    setGroupOpen(group, open) {
      group.querySelector('.facet-group__toggle').setAttribute('aria-expanded', open);
      group.querySelector('.facet-group__panel').hidden = !open;
    }

    setShowAll(group, open) {
      group.querySelector('[data-facet-more]')?.setAttribute('aria-expanded', open);
      group.querySelectorAll('[data-facet-extra]').forEach((item) => (item.hidden = !open));
    }

    /* 差し替えた絞り込みに、開閉と「すべて表示」の状態を引き継ぐ */
    applyGroupState() {
      this.querySelectorAll('[data-facet-group]').forEach((group) => {
        if (this.collapsed.has(group.dataset.facetGroup)) this.setGroupOpen(group, false);
        if (this.expanded.has(group.dataset.facetGroup)) this.setShowAll(group, true);
      });
    }

    openDrawer(opener) {
      this.opener = opener;
      /* スマホのドロワーは、上の2項目と選択中の項目だけを開いておく */
      if (!this.mobileStateApplied) {
        this.querySelectorAll('[data-mobile-closed]').forEach((group) => this.collapsed.add(group.dataset.facetGroup));
        this.mobileStateApplied = true;
        this.applyGroupState();
      }
      this.querySelector('[data-drawer-body]').append(this.querySelector('[data-filter-panel]'));
      this.drawer.showModal();
    }

    onDrawerClose() {
      this.querySelector('[data-filter-home]').append(this.querySelector('[data-filter-panel]'));
      if (!this.desktopQuery.matches) this.querySelector('[data-filter-open]')?.focus();
    }

    openSort() {
      this.querySelector('[data-sort-toggle]').setAttribute('aria-expanded', 'true');
      const menu = this.querySelector('.product-listing__sort-menu');
      menu.hidden = false;
      (menu.querySelector('[aria-current="true"]') || menu.querySelector('button'))?.focus();
    }

    closeSort(focusButton) {
      const button = this.querySelector('[data-sort-toggle]');
      if (!button) return;
      button.setAttribute('aria-expanded', 'false');
      this.querySelector('.product-listing__sort-menu').hidden = true;
      if (focusButton) button.focus();
    }
  }

  if (!customElements.get('product-listing')) customElements.define('product-listing', ProductListing);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-arrows"] && !Shopify.designMode) return;
  try {
    class ScrollArrows extends HTMLElement {
    connectedCallback() {
      this.track = this.parentElement?.querySelector(this.dataset.track);
      if (!this.track) return;
      this.previous = this.querySelector('[data-direction="-1"]');
      this.next = this.querySelector('[data-direction="1"]');
      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));

      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      // 人気商品ランキングは、読み込んだあとに列の中身を差し替える
      this.mutationObserver = new MutationObserver(() => this.update());
      this.mutationObserver.observe(this.track, { childList: true });
      this.update();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
    }

    /* 見えている枚数ぶん進む（カードの並びに合わせて止まる） */
    move(direction) {
      const item = this.track.firstElementChild;
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = item.getBoundingClientRect().width + gap;
      const visible = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
      const max = this.track.scrollWidth - this.track.clientWidth;
      const left = Math.min(Math.max(this.track.scrollLeft + direction * visible * step, 0), max);
      this.track.scrollTo({ left, behavior: 'smooth' });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const overflowing = max > 1;
      this.previous.disabled = !overflowing || this.track.scrollLeft <= 1;
      this.next.disabled = !overflowing || this.track.scrollLeft >= max - 1;
      // 画像の縦中央に置く
      const media = this.track.querySelector(this.dataset.media);
      if (media && media.offsetHeight) this.style.setProperty('--scroll-arrows-top', `${media.offsetHeight / 2}px`);
    }
  }

  if (!customElements.get('scroll-arrows')) customElements.define('scroll-arrows', ScrollArrows);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-dialog"] && !Shopify.designMode) return;
  try {
    class SizeGuideDialog extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.openers = document.querySelectorAll(`[aria-controls="${this.dialog.id}"]`);

      /* 新しいタブで開く操作（Ctrl・Cmd・Shift を押しながら・中ボタン）は、リンクのまま */
      this.openers.forEach((opener) => {
        opener.addEventListener('click', (event) => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.open(opener);
        });
      });

      this.dialog.addEventListener('click', (event) => {
        const box = this.dialog.getBoundingClientRect();
        const outside =
          event.clientX < box.left ||
          event.clientX > box.right ||
          event.clientY < box.top ||
          event.clientY > box.bottom;
        if (outside || event.target.closest('[data-size-guide-close]')) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.opener?.focus({ preventScroll: true }));
    }

    open(opener) {
      const body = this.querySelector('[data-size-guide-body]');
      if (!body.hasChildNodes()) {
        const content = this.querySelector('template').content.cloneNode(true);
        content.querySelectorAll('style').forEach((style) => style.remove());
        body.append(content);
      }
      this.opener = opener;
      this.dialog.showModal();
      body.scrollTop = 0;
    }
  }

  if (!customElements.get('size-guide-dialog')) customElements.define('size-guide-dialog', SizeGuideDialog);
  } catch(e) { console.error(e); }
})();

})();
